import {Component, Input} from '@angular/core';
import {SnackBarComponent} from '../../snackbar/snackbar.component';
import {TeamCompaniesService} from '../../../services/teamcompanies/teamcompanies.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-agency-profile',
  templateUrl: './agency-profile.component.html',
  styleUrls: ['./agency-profile.component.scss']
})
export class AgencyProfileComponent {

  @Input() companyId = '';

  constructor(
      private teamCompaniesService: TeamCompaniesService,
      private snackBar: MatSnackBar
  ) {
  }

  saveAgencyProfile(data: any): void {
    this.teamCompaniesService.modifyCompany(this.companyId, data).then(() => {
      this.snackBar.openFromComponent(SnackBarComponent, {data: 'Agency profile saved'});
    });
  }

}
